import { TrackLocation } from "@tvg/ts-types/Race";

export const buildQALabel = (labels: string[]) =>
  labels.filter(Boolean).join("-");

export const getFlagLabel = (location?: TrackLocation) => {
  if (location?.country === "USA" && location?.state) return location?.state;
  return location?.country ?? "";
};
